// refactor sass to stylejs (no theme usage)
import { styled } from '@mui/material/styles';
import { css } from '@emotion/react';
import { UiDialog } from 'ui-components';

export const StyledExportContent = styled('div')(
  ({ theme }) => css`
    .random-sort {
      margin: 12px 0 0 !important;
    }

    .excel-format-title {
      font-size: 0.87rem;
      font-weight: 700;
      line-height: 1.5rem;
      margin-top: 12px;
    }

    .excel-format-radios {
      .MuiFormControlLabel-root {
        &:first-of-type {
          margin-right: 0 !important;
        }
      }
    }

    .export-content {
      .Mui-disabled {
        color: #e4e9ec !important;

        .icon {
          color: inherit;
        }
      }
    }

    .platform-picker {
      margin-top: 12px;
    }

    .platform-options {
      display: flex;
      flex-wrap: wrap;
      gap: 8px;
      justify-content: flex-start;
      margin-top: 8px;
    }

    button.platform-chip.MuiButton-root {
      min-width: auto;
      height: auto;
      padding: 8px 8px 8px 12px !important;
      border-radius: 8px !important;
      border: 1px solid ${theme.palette.gray.lighter} !important;
      background-color: ${theme.palette.naturals.white} !important;
      color: ${theme.palette.secondary.light} !important;
      font-size: 12px !important;
      font-weight: 400 !important;
      line-height: 24px !important;
      text-transform: none;
      box-shadow: none !important;

      span {
        display: flex;
        align-items: center;
        gap: 8px;
        color: inherit !important;
      }

      &:hover,
      &:focus,
      &:active {
        background-color: ${theme.palette.naturals.white} !important;
        border-color: ${theme.palette.gray.lighter} !important;
        color: ${theme.palette.secondary.light} !important;
        box-shadow: none !important;
      }

      &.is-selected,
      &.is-selected:hover,
      &.is-selected:focus,
      &.is-selected:active {
        border-color: ${theme.palette.primary.main} !important;
        background-color: #f1feff !important;
        color: ${theme.palette.primary.main} !important;
      }
    }

    .platform-picker-error {
      display: block;
      margin-top: 8px;
      color: #b71d18;
      font-size: 12px;
      font-weight: 400;
      line-height: 24px;
    }

    .export-excel-ring-chart {
      .tooltip {
        padding: 10px 0;
        justify-content: space-between;
        gap: 20px;

        .tooltip-title,
        .tooltip-value {
          white-space: nowrap;
        }

        .tooltip-value {
          font-weight: 700;
        }
      }

      .ring-chart-legend {
        font-size: 0.8rem;
        margin-top: 8px;

        .legend-title {
          font-weight: 700;
        }
        .legend-subtitle {
          font-size: 0.75rem;
        }
      }
    }
  `
);

export const StyledExportContentDialog = styled(UiDialog)(
  () => css`
    &.export-content-modal {
      .label {
        font-size: 0.75rem;
        font-weight: 700;
        line-height: 1.5rem;
      }

      .export-excel-title {
        padding: 12px 20px !important;
      }

      .export-excel-content {
        padding: 16px 20px !important;
      }

      .export-excel-actions {
        justify-content: space-between;

        button {
          min-width: 100px;
          margin: 0;

          &:last-child {
            margin-right: 16px;
          }

          &.action-advanced-button {
            margin-right: 0 !important;
          }
        }
      }

      .export-content-fields {
        .export-content-field {
          width: 35%;
        }
      }
    }
  `
);
